import axios from "axios";
import moment from "moment";
import { connect } from "react-redux";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { NEW_API_URL } from "../../../constants/Globals";
import { Pagination } from "react-bootstrap";
import OrganizationSelector from "../../OrganizationSelector";
import { fetchAiResponseLimitExceedStatus, fetchClientSubscriptionStatus } from "../../../services/SubscriptionSvc";
import { getClientOrganization } from "../../../services/NetworkSvc";

function Campaigns({ selNetworkId, groups = [] }) {
  const [loading, setLoading] = useState(true);
  const [campaigns, setCampaigns] = useState([]);
  const [count, setCount] = useState(0);
  const [sortBy, setSortBy] = useState("id");
  const [state, setState] = useState(0);
  const [pageSearch, setPageSearch] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize] = useState(10);
  const [groupList, setGroupList] = useState([]);
  const [isClientSubscriptionActive, setIsClientSubscriptionActive] = useState(false);
  const [isAiResponseLimitExceed, setIsAiResponseLimitExceed] = useState(false);

  const getIsSubscriptionActiveStatus = async (selNetworkId) => {
    const isActive = await fetchClientSubscriptionStatus(selNetworkId);
    setIsClientSubscriptionActive(isActive);
  }

  const getAILimitExceedStatus = async (selNetworkId) => {
    const groupId = await getClientOrganization(selNetworkId);
    // console.log('Group id for AI limit check:::::::::::::', groupId);
    if (groupId && groupId > 0) {
      const isAiRespLimitExceed = await fetchAiResponseLimitExceedStatus(groupId);
      // console.log('AI response limit exceed status:::::::::::::::::', isAiRespLimitExceed);
      setIsAiResponseLimitExceed(isAiRespLimitExceed);
    } else {
      alert('Organiation not found for the selected network!!!');
    }
  }

  useEffect(() => {
    if (selNetworkId) {
      getIsSubscriptionActiveStatus(selNetworkId);
      getAILimitExceedStatus(selNetworkId);
    }
  }, [selNetworkId]);

  useEffect(() => {
    if (selNetworkId && groups.length > 0) {
      const selectedGroups =
        groupList.length > 0 ? groupList : groups.map((g) => g.groupId);
      axios
        .get(`${NEW_API_URL}/campaigns`, {
          params: {
            perPage: pageSize,
            pageNumber: pageNumber,
            search: pageSearch,
            formId: "",
            groups: selectedGroups.join(","),
            // networkId: selNetworkId,
          },
        })
        .then(({ data }) => {
          setLoading(false);
          setCampaigns(data.rows);
          setCount(data.count);
        });
    }
  }, [
    selNetworkId,
    sortBy,
    pageSearch,
    pageNumber,
    pageSize,
    state,
    groupList,
    groups,
  ]);

  const handleCreateCampaignClick = () => {
    if (isClientSubscriptionActive) {
      if (isAiResponseLimitExceed) {
        alert(`You've reached your limit for responses. Please upgrade or wait until limits reset`);
      } else {
        window.location.href = `/campaigns/upsert/0`;
      }
    } else {
      window.location.href = `/subscription-renew`;
    }
  }

  return (
    <div className="segments">
      <div className="page-headline is-flex">
        <div>
          <strong>Advertising</strong>&nbsp;|&nbsp;Campaigns
        </div>
        {/* <Link to="/campaigns/upsert/0" className="blue-button size-l">
          Create Campaign
        </Link> */}
        <button
          className="btn btn-primary"
          onClick={handleCreateCampaignClick}
        >
          Create Campaign
        </button>
      </div>
      {groups && groups.length > 1 ? (
        <div className="w-25">
          <OrganizationSelector
            value={groupList}
            onChange={(e) => {
              setGroupList(e);
              setPageNumber(1);
            }}
            multiple={true}
            groups={groups}
            forCampaigns={true}
          />
        </div>
      ) : null}
      <form
        id="search"
        autoComplete="off"
        className="searchForm1 mt-4"
        onSubmit={(e) => e.preventDefault()}
      >
        <input
          onChange={(e) => setPageSearch(e.target.value)}
          type="text"
          className="form-control"
          value={pageSearch}
          name="pageSearch"
          placeholder={"Search for a campaigns"}
        />
      </form>
      <div className="table-filters sorting">
        <div className="table-filters-start">
          <div className="table-sorter">
            <label>Sort by</label>
            <select
              value={sortBy}
              onChange={({ target }) => setSortBy(target.value)}
            >
              <option value="date">Most Recent</option>
              <option value="name">Name</option>
            </select>
          </div>
        </div>

        <div>
          <Pagination size="md" style={{ margin: "0" }}>
            <div className="table-pagination mx-2">{count} Campaigns</div>
            <Pagination.Prev
              style={{ background: "transparent", border: "none" }}
              onClick={() => {
                if (pageNumber > 1) setPageNumber(pageNumber - 1);
              }}
            />
            <span
              className="text-sm-end"
              style={{
                fontSize: "11px",
                lineHeight: "2.5",
                marginRight: "4px",
                marginLeft: "4px",
              }}
            >
              {pageNumber} of {Math.ceil(count / pageSize)}
            </span>
            <Pagination.Next
              style={{ background: "transparent", border: "none" }}
              onClick={() => {
                if (pageNumber < count / pageSize)
                  setPageNumber(pageNumber + 1);
              }}
            />
          </Pagination>
        </div>
      </div>
      <div className="table-wrapper">
        <table
          className="table-body top-border"
          cellSpacing="0"
          cellPadding="0"
        >
          <tbody>
            {loading ? (
              <tr className="table-row">
                <td className="table-cell table-cell-fluid">
                  <em>Loading...</em>
                </td>
              </tr>
            ) : null}

            {!loading && !campaigns.length ? (
              <tr className="table-row">
                <td className="table-cell table-cell-fluid">
                  <em>No campaigns yet...</em>
                </td>
              </tr>
            ) : null}

            {campaigns.map(
              ({
                id,
                title,
                description,
                createdAt,
                updatedAt,
                responseCount,
                responseCountTarget,
                isClosed,
                spend,
                startDate,
                endDate,
              }) => (
                <tr key={id} className="table-row">
                  <td className="table-cell table-cell-fluid">
                    <Link
                      to={`/campaigns/upsert/${id}`}
                      className="text-button inherit-font"
                    >
                      {title}
                    </Link>
                  </td>
                  <td className="table-cell table-cell-labelled" width="150">
                    <div>
                      Created
                      <br />
                      <strong>{moment(createdAt).format("MMM DD, Y")}</strong>
                    </div>
                  </td>
                  <td className="table-cell table-cell-labelled" width="150">
                    <div>
                      Responses
                      <br />
                      <strong>
                        {responseCount ?? 0} / {responseCountTarget}
                      </strong>
                    </div>
                  </td>
                  {/* <td className="table-cell table-cell-labelled" width="150">
                    <div>
                      Spend
                      <br />
                      <strong>
                        {spend ?? 0}
                      </strong>
                    </div>
                  </td> */}
                  {/* <td className="table-cell table-cell-labelled" width="320">
                    <div>
                      Duration
                      <br />
                      <strong>
                        {moment(startDate).format("MM/DD/YY @ hh:mmA")} -{" "}
                        {moment(endDate).format("MM/DD/YY @ hh:mmA")}
                      </strong>
                    </div>
                  </td> */}
                  <td className="table-cell table-action" width="280">
                    <div className="inline-buttons">
                      {isClosed ? (
                        <span className="badge badge-primary">Closed</span>
                      ) : (
                        <>
                          <Link
                            to={`/campaigns/upsert/${id}`}
                            className="blue-button bordered"
                            style={{ marginRight: "8px" }}
                          >
                            Edit
                          </Link>
                          <button
                            className="blue-button bordered"
                            onClick={() => {
                              if (
                                window.confirm(
                                  "Are you sure you want to delete this campaign? This action is permanent and can't be reversed."
                                )
                              ) {
                                axios
                                  .delete(`${NEW_API_URL}/campaigns/${id}`)
                                  .then(() => setState(state * 2))
                                  .then(() => {})
                                  .catch(({ response }) => {
                                    if (response.status === 500) {
                                      alert(
                                        JSON.stringify(response.data.message)
                                      );
                                    }
                                  });
                              }
                            }}
                          >
                            Delete
                          </button>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              )
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  selNetworkId: state.networks.selNetworkId,
  groups: state.networks.groupsList,
});

export default connect(mapStateToProps)(Campaigns);
